import { Link } from '@reach/router';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { signOut } from 'reducers/auth';
import Cookies from 'universal-cookie';

interface LinkData {
  accessElementID: number;
  displayName: string;
  url: string;
}

type HeaderDropdownMenuProps = {
  initials: string;
  linkListData: LinkData[];
};

export const HeaderDropdownMenu: React.FC<HeaderDropdownMenuProps> = ({
  initials,
  linkListData,
}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const cookies = new Cookies();
  const cookieBannerSetting = cookies.get('cookie_settings');  

  const toggleIsOpen = () => {
    setIsOpen((oldVal) => !oldVal);
  };

  const bind = useOnClickOutside(() => setIsOpen(false));

  const handleSignOut = () => {
    dispatch(signOut());
  };

  return (
    <div className="HeaderDropdownMenu" {...bind}>
      <div className="OpenButton" onClick={toggleIsOpen}>
        <span>{cookieBannerSetting && cookieBannerSetting !== "functional" && cookieBannerSetting !== "functional_and_marketing" ? initials : "GS"}</span>
      </div>
      <div className={`Menu ${isOpen ? 'Open' : ''}`}>
        <ul>
          {linkListData &&
            linkListData.map((item: LinkData, index: number) => {
              if (item.displayName !== 'Sign out') {
                return (
                  <li key={index}>
                    <Link
                      to={
                        '/' +
                        item.displayName.toLowerCase().replaceAll(' ', '-')
                      }
                    >
                      {item.displayName}
                    </Link>
                  </li>
                );
              }
            })}
          <li onClick={handleSignOut}>
            <span className="SignOut">Sign out</span>
          </li>
        </ul>
      </div>
    </div>
  );
};
